export default __webpack_public_path__ + "static/media/QR_code_AppStore.77f3bc7d.png";